import React from "react";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import * as R from "ramda";
import { styled } from "@mui/material/styles";
import { MOP_TYPES } from "../../contants";
import styles from "./buttons.module.scss";

function MopButtons({ mopType, setter }) {
  const { t } = useTranslation(["common"]);

  const handleChange = (event, newMopType) => {
    if (newMopType !== null) {
      setter(newMopType);
    }
  };

  const control = {
    value: mopType,
    onChange: handleChange,
    exclusive: true,
  };

  const Button = styled(ToggleButton)(({ theme }) => ({
    backgroundColor: "white",
    borderRadius: "10px",
    border: "1px #979797 solid",
    textTransform: "initial",
    "&.Mui-selected": {
      color: "white",
      backgroundColor: `${theme.palette.primary.main} !important`,
    },
    "&.MuiToggleButtonGroup-grouped:not(:first-of-type)": {
      borderLeft: "1px #979797 solid",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.5rem !important",
      padding: "1rem",
    },
  }));

  const children = R.values(MOP_TYPES).map((type) =>
    type.startsWith("i-mop") ? (
      <Button
        value={type}
        key={type}
        sx={{
          "&:hover": {
            backgroundColor: "button.main.active.background",
            color: "button.main.active.text",
          },
        }}
      >
        {type}
      </Button>
    ) : null
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography className={styles.caption}>
        {t("Select a product to compare the savings")}
      </Typography>
      <ToggleButtonGroup
        className={styles.buttonsGroup}
        size="large"
        {...control}
      >
        {children}
      </ToggleButtonGroup>
    </Box>
  );
}

export default MopButtons;
